import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Button';
import CruiseBenefitsModal from './CruiseBenefitsModal';

const CruiseBenefits = ({ virtuosoVoyage, buttonTitle }) => {
  const [open, setOpen] = useState(false);

  if (!virtuosoVoyage || !virtuosoVoyage.hasBenefits) {
    return <></>;
  }

  const toggleOpen = () => {
    setOpen((r) => !r);
  };

  return (
    <>
      <Button
        variant={Button.buttonVariants.LINK}
        size={Button.buttonSizes.SM}
        onClick={toggleOpen}
        className="focus:outline-none"
      >
        {buttonTitle}
      </Button>
      {open && (
        <CruiseBenefitsModal virtuosoVoyage={virtuosoVoyage} open={open} onClose={toggleOpen} />
      )}
    </>
  );
};

CruiseBenefits.propTypes = {
  virtuosoVoyage: PropTypes.shape().isRequired,
  buttonTitle: PropTypes.string,
};

CruiseBenefits.defaultProps = {
  buttonTitle: 'View cruise benefits',
};
export default CruiseBenefits;
